import type { LiveStatus } from '@liveforge/shared';

export interface StatusBadgeProps {
  status: LiveStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return <span className={`badge badge--${status}`}>{status}</span>;
}
